import React from "react";
import { Box, TextField, Typography, Link } from "@mui/material";
import { Formik, Form, Field, ErrorMessage, FormikProps } from "formik";

import "./login.scss";
import styles from "./login.style";
import loginHelper from "./helper";
import { IMAGES } from "../../common/constants";
import Schema from "../../common/constants/schema";
import { LoginFormValues } from "./services/types";
import ContainedButton from "../../components/button/contained-button";

export default function Login() {
  const {
    cmsLinks,
    loginInitialValue,

    handleSupportClick,
    onSubmitEmailHandler,
  } = loginHelper();

  return (
    <div className="login-container container-width">
      <div>
        <h1>Welcome to Databis™</h1>
        <h2 className="login-subheading">The Sale-to-Smoke™ Platform</h2>
        <Formik<LoginFormValues>
          onSubmit={onSubmitEmailHandler}
          validationSchema={Schema.LoginSchema}
          initialValues={{ ...loginInitialValue }}
        >
          {(props: FormikProps<LoginFormValues>) => (
            <Form>
              <Typography variant="h6" component="label" sx={styles.label}>
                Email<sup>*</sup>
              </Typography>

              <Field
                as={TextField}
                id="email"
                name="email"
                variant="outlined"
                placeholder="Enter Email"
                fullWidth
                error={props.touched.email && Boolean(props.errors.email)}
                helperText={<ErrorMessage name="email" />}
                sx={styles.authInput}
              />
              <Box sx={styles.btnContainer}>
                <ContainedButton
                  title="Send Login Code"
                  externalStyles={styles.btn}
                  fullWidth
                  size="large"
                  type="submit"
                  disabled={!props.values.email || !!props.errors.email}
                />
              </Box>

              <Box sx={styles.btnwrapper}>
                <Typography component="a" onClick={handleSupportClick}>
                  Can't Login
                </Typography>
              </Box>

              <Box>
                <div className="cms-link-wrapper wraps">
                  <div className="cms_links">
                    <Link
                      href={cmsLinks?.privacy_policy}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="link"
                    >
                      Privacy Policy
                    </Link>
                    <Link
                      href={cmsLinks?.terms_of_use}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="link"
                    >
                      Terms of Use
                    </Link>
                  </div>

                  <div className="links privacyChoice login_choice_link">
                    <img
                      src={IMAGES.PrivacyChoiceIcon}
                      alt="Privacy Choice Icon"
                      className="privacyIcon"
                    />
                    <Link
                      href={cmsLinks?.your_privacy_choices}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="link"
                    >
                      Your Privacy Choices
                    </Link>
                  </div>
                </div>
              </Box>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}
